import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n      ",
        " {\n        box-shadow: ",
        ";\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Container, Desktop } from "@miro-site/core";
import React, { useRef, useEffect, useState } from "react";
import styled, { css } from "styled-components";
import CategoryNav, { Button as CategoryNavButton } from "../category-nav/CategoryNav";
import Search, { SearchWrapper as SearchInputWrapper } from "../search/Search";
var TopBarWrapper = styled(Box).attrs(function(param) {
    var theme = param.theme, $isFixed = param.$isFixed, _$styles = param.$styles, $styles = _$styles === void 0 ? {} : _$styles;
    return {
        $styles: _object_spread({}, $isFixed ? {
            position: "fixed",
            paddingTop: [
                8,
                17,
                17,
                17
            ],
            paddingBottom: [
                8,
                17,
                17,
                17
            ],
            boxShadow: theme.templates.elevation.topBar,
            backgroundColor: "primaryWhite",
            top: 0,
            right: 0,
            left: 0,
            zIndex: 700
        } : {
            position: "relative"
        }, $styles)
    };
})({});
var TopBarSearch = styled(Search).withConfig({
    componentId: "sc-f596f357-0"
})(_templateObject1(), function(param) {
    var $isActive = param.$isActive, $isFixed = param.$isFixed, theme = param.theme;
    return $isActive && $isFixed && css(_templateObject(), SearchInputWrapper, theme.templates.elevation.fixedSearch);
});
var TopBar = function(param) {
    var rootGroups = param.rootGroups, onSearch = param.onSearch, searchResult = param.searchResult, statusMessages = param.statusMessages, isSearching = param.isSearching, onCategoryNavOpened = param.onCategoryNavOpened, onSelectTemplate = param.onSelectTemplate, onSelectCategory = param.onSelectCategory, backButton = param.backButton, categoriesButtonLabel = param.categoriesButtonLabel, _isSticky = param.isSticky, isSticky = _isSticky === void 0 ? false : _isSticky;
    var ref = useState(false), categoryNavOpened = ref[0], setCategoryNavOpened = ref[1];
    var ref1 = useState(false), isSearchActive = ref1[0], setSearchActive = ref1[1];
    var navRef = useRef(null);
    var navButtonRef = useRef(null);
    var handleClick = function(e) {
        var clickOnNavButton = navButtonRef.current && navButtonRef.current.contains(e.target);
        if (clickOnNavButton) {
            return;
        }
        var clickOutsideNav = navRef.current && !navRef.current.contains(e.target);
        if (clickOutsideNav) {
            setCategoryNavOpened(false);
        }
    };
    useEffect(function() {
        if (!categoryNavOpened) {
            return;
        }
        if (onCategoryNavOpened) {
            onCategoryNavOpened();
        }
        document.addEventListener("click", handleClick, true);
        window.addEventListener("focusin", onFocusCategoryDown);
        return function() {
            document.removeEventListener("click", handleClick, true);
            document.removeEventListener("keydown", onFocusCategoryDown);
        };
    }, [
        categoryNavOpened
    ]);
    var onKeyDownHandler = function(event) {
        if (event.key === "Enter") {
            event.preventDefault();
            event.stopPropagation();
            setCategoryNavOpened(!categoryNavOpened);
        }
    };
    var onFocusCategoryDown = function onFocusCategoryDown() {
        if (navRef.current && document.activeElement !== navButtonRef.current && !navRef.current.contains(document.activeElement)) {
            setCategoryNavOpened(false);
        }
    };
    var searchContainerStyles = {
        width: !isSearchActive ? [
            40,
            394,
            394,
            394
        ] : "100%",
        marginLeft: [
            "auto",
            0,
            0,
            0
        ],
        position: "relative"
    };
    return /*#__PURE__*/ _jsx(TopBarWrapper, {
        $isFixed: isSticky,
        children: /*#__PURE__*/ _jsx(Container, {
            children: /*#__PURE__*/ _jsxs(Box, {
                $styles: {
                    justifyContent: backButton ? "flex-start" : "center",
                    alignItems: "center",
                    display: "flex",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            backButton && /*#__PURE__*/ _jsx(Desktop, {
                                $mr: "auto",
                                $styles: {
                                    position: isSearchActive ? "absolute" : "relative"
                                },
                                children: backButton
                            }),
                            /*#__PURE__*/ _jsx(CategoryNavButton, {
                                ref: navButtonRef,
                                $mr: 12,
                                isOpened: categoryNavOpened,
                                onClick: function() {
                                    setCategoryNavOpened(!categoryNavOpened);
                                },
                                onKeyDown: onKeyDownHandler,
                                isSearchActive: isSearchActive,
                                children: categoriesButtonLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(CategoryNav, {
                        ref: navRef,
                        isVisible: categoryNavOpened,
                        rootGroups: rootGroups,
                        onMobilePopupClose: function() {
                            setCategoryNavOpened(false);
                        },
                        onCategoryOpen: function(category) {
                            setCategoryNavOpened(false);
                            if (onSelectCategory) {
                                onSelectCategory(category);
                            }
                        }
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        $styles: searchContainerStyles,
                        children: /*#__PURE__*/ _jsx(TopBarSearch, {
                            $isActive: isSearchActive,
                            $isFixed: isSticky,
                            onSearch: onSearch,
                            searchResult: searchResult,
                            statusMessages: statusMessages,
                            isSearching: isSearching,
                            onSelectTemplate: onSelectTemplate,
                            onFocusChanged: function(isFocused) {
                                setSearchActive(isFocused);
                                if (isFocused) {
                                    setCategoryNavOpened(false);
                                }
                            }
                        })
                    })
                ]
            })
        })
    });
};
export default TopBar;
